import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';
import { chooseLocation, disconnect } from '../../js/google_my_business';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'locationInput',
        'chooseButton',
    ];

    connect() {
        this.modal = new Modal(this.element, {
            backdrop: 'static',
            focus: false,
            show: false,
        });

        this.modal.show();
    }

    selectLocation() {
        this.chooseButtonTarget.disabled = !this.locationInputTargets.some(locationInput => locationInput.checked);
    }

    async choose() {
        const selectedLocationInput = this.locationInputTargets.find(locationInput => locationInput.checked);

        const { isSuccess, message } = await chooseLocation({ location: selectedLocationInput.value });

        if (isSuccess) {
            showPreloader();

            window.location.reload();
        } else {
            addAlert('danger', message || translations['profile.An unknown error occurred.']);
        }
    }

    async retry({ params: { url } }) {
        const { isSuccess, message } = await disconnect();

        if (isSuccess) {
            showPreloader();

            window.dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    action: 'gmb_retry_choose_location_click',
                    category: 'Account',
                    label: '',
                },
            });

            window.location = url;

            this.modal.hide();
        } else {
            addAlert('danger', message || translations['profile.An unknown error occurred.']);
        }
    }
}
